import React from 'react';
import reportsService from '../../../../../../../../../../services/reportsService/reportsService';
import { PdfDownloadButton } from '../../../../../../../../../common/PDF/PdfDownloadButton';

/**
 * MisBlankPdfDownloadButton component renders a button that allows users to download a blank PDF version of the Management Information Systems report form.
 * It handles the download process, including error handling and user notifications.
 * @returns {JSX.Element} The rendered MisBlankPdfDownloadButton component.
 */
export const MisBlankPdfDownloadButton = () => {
    return (
        <PdfDownloadButton
            fetchPdf={reportsService.getBlankMisReportForm}
            filename="BlankMisReportForm.pdf"
            tooltip={<span style={{ maxWidth: 220, whiteSpace: 'normal', display: 'block', textAlign: 'center' }}>
                Click here to download a blank PDF version of the Management Information Systems report form.
            </span>}
            buttonTitle="Blank MIS Report"
            buttonContent="Blank MIS Report"
            toolTipPosition="left"
        />
    );
};